import React, { useState, useEffect } from "react";

import { Button, Col, Form, Row, InputGroup, Spinner } from "react-bootstrap";

import { useNavigate, useParams } from "react-router-dom";

import { toast } from "react-toastify";

import Cost from "./Cost";

import "./home.scss";

import HeadMeta from "../../other/HeadMeta";

import FunctionHome from "./FunctionHome";

import api from "../../../utils/axiosPublic";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { faCheck, faPencil } from "@fortawesome/free-solid-svg-icons";

import FeedbackStrip from "./FeedbackStrip";

function HomeIndex() {
  useEffect(() => {
    document.title =
      "Kafood | Phần mềm quản lý suất ăn và định lượng dinh dưỡng";

    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const { slug } = useParams();

  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);

  const [contactData, setContactData] = useState({
    phone: "",

    fullName: "",

    message: "",
  });

  const dataFeedback = [
    {
      school_name: "Mầm non quân khu 9",

      id: 0,

      src: "assets/user/images/product/feedback/quankhu9.jpg",

      represent: " Chị Lâm Thị Tuyết An (Hiệu trưởng)",

      cmt: "Kafood là phần mềm quản lý đầy đủ chức năng, mang lại hiệu quả cao và đơn giản hơn trong quá trình quản lý.",
    },

    {
      school_name: "Mầm non niềm tin",

      id: 1,

      src: "assets/user/images/product/feedback/niemtin.jpg",

      represent: " Anh Văn Nhựt Vương (Hiệu trưởng)",

      cmt: "Kafood là phần mềm mà tôi nghĩ nó giải pháp tốt nhất cho đến thời điểm hiện tại dùng để quản lý các trường mầm non.",
    },

    {
      school_name: "Mần Non Hà Nguyễn",

      id: 3,

      src: "assets/user/images/product/feedback/hanguyen.jpg",

      represent: "Chị Nguyễn Thị Hà (Chủ cơ sở)",

      cmt: "Từ khi sử dụng phần mềm Kafood nhóm trẻ của tôi hoàn thành các báo cáo phòng sở, báo cáo sổ 3 bước rất nhanh, có thời gian để tập trung chăm sóc trẻ hơn.",
    },

    {
      school_name: "Nhóm trẻ độc lập Tre Việt",

      id: 4,

      src: "assets/user/images/product/feedback/treviet.jpg",

      represent: "Anh Trần Việt Thi (Chủ cơ sở)",

      cmt: "Kafood có ngân hàng món ăn rất nhiều món, tôi không còn đau đầu suy nghĩ món ăn lên thực đơn mỗi tuần.",
    },
  ];

  const sendSDT = async (e) => {
    e.preventDefault();

    if (contactData.phone.toString().length < 10) {
      toast(`Vui lòng nhập số điện thoại từ 10 chữ số.`, {
        type: "error",

        autoClose: 1000,

        style: { marginTop: "50px" },
      });

      return;
    }

    await handleSaveCustomer();
  };

  const handleSaveCustomer = async () => {
    const phone = contactData.phone.toString();

    const data = {
      fullName: "Không",

      phone: phone,

      slug: slug,
    };

    try {
      setIsLoading(true);

      const res = await api.post(`/customer/create`, data);

      if (res.data.errCode === 0) {
        navigate("/dang-ky-thanh-cong");

        toast(`Đăng ký thành công`, {
          type: "success",

          autoClose: 1000,

          style: { marginTop: "50px" },
        });
      }
    } catch (error) {
      if (error.response.data?.messages?.phone) {
        toast(error.response.data?.messages?.phone, { type: "error" });
      }
    } finally {
      setIsLoading(false);
    }
  };

  const meta = {
    title: "Kafood | Phần mềm quản lý suất ăn và định lượng dinh dưỡng",

    description:
      "Kafood - Phần mềm quản lý suất ăn và định lượng dinh dưỡng trẻ mầm non. ",

    keywords:
      "Kafood, Phần mềm quản lý suất ăn, định lượng dinh dưỡng trẻ mầm non",

    og_image:
      process.env.REACT_APP_FRONTEND_URL +
      "/assets/user/images/product/detail/5_5.png",

    og_image_type: "image/png",
  };

  return (
    <div id="page_home">
      <HeadMeta {...meta} />

      <div className="page-content-product">
        <div className="main-product">
          <div className="find-box">
            <h1 className="text-center fw-bold text-navy">
              PHẦN MỀM QUẢN LÝ SUẤT ĂN <br />
              VÀ ĐỊNH LƯỢNG DINH DƯỠNG
            </h1>

            <div className="product-sh">
              <Form onSubmit={(e) => sendSDT(e)} className="form_input_phone">
                <Row className="m-0 justify-content-center">
                  <Col lg={4} md={6}>
                    <InputGroup className="mb-3">
                      <Form.Control
                        placeholder="Nhập số điện thoại..."
                        name="phone"
                        onChange={(e) =>
                          setContactData({
                            ...contactData,
                            phone: e.target.value,
                          })
                        }
                        value={contactData.phone}
                      />

                      <pre> </pre>

                      <Button
                        variant="primary"
                        type="submit"
                        disabled={isLoading}
                      >
                        {isLoading ? (
                          <>
                            <Spinner animation="border" size="sm" /> Đang đăng
                            ký...
                          </>
                        ) : (
                          <> Đăng ký tư vấn</>
                        )}
                      </Button>
                    </InputGroup>
                  </Col>
                </Row>
              </Form>
            </div>
          </div>
        </div>
      </div>

      <div className="cat-main-box bg-white">
        <div className="container py-4">
          <div className="row panel-row">
            <div className="function">
              <div className="title_home">
                <div className="text_title">
                  <h2 className="text-navy">
                    Giải pháp chuyển đổi số cho trường học
                  </h2>
                </div>
              </div>

              <FunctionHome />
            </div>
          </div>

          <center className="mt-5 mb-5">
            <a
              href="/dang-ky-dung-thu"
              className="button-71 transform-scale-1-1"
            >
              <FontAwesomeIcon icon={faPencil} /> Đăng ký dùng thử
            </a>
          </center>
        </div>
      </div>

      <Cost />

      <div className="container">
        <Row>
          <Col md={6} className="mb-3 p-3 p-md-0 pe-md-2">
            <div className="title_home">
              <div className="text_title">
                <h2>GIỚI THIỆU KAFOOD</h2>
              </div>
            </div>

            {/* <p className="fs-5 text-justify px-3 px-md-0">

Phần mềm quản lý suất ăn giúp quản lý các thông tin về suất ăn của

trẻ trong trường mầm non. Các thông tin này gồm số lượng suất ăn,

thực đơn, định lượng dinh dưỡng và các thông tin liên quan đến

trường học.

</p> */}

            <p className="text-justifyimageGGPlay">
              Kafood số hoá quy trình bếp cho trường học/bếp ăn:
            </p>

            <p className="text-justify">
              <FontAwesomeIcon icon={faCheck} className="text-success" /> Lập
              thực đơn, tính dinh dưỡng (kcal, P-L-G), dự trù–mua–kho, nấu và
              chia suất.
            </p>

            <p className="text-justify">
              <FontAwesomeIcon icon={faCheck} className="text-success" /> Hệ
              thống chuẩn hoá khẩu phần theo lứa tuổi, hỗ trợ chế độ đặc biệt
              (dị ứng, ăn chay).
            </p>

            <p className="text-justify">
              <FontAwesomeIcon icon={faCheck} className="text-success" /> Dự trù
              tự động theo sĩ số, xuất kho FIFO/FEFO, theo dõi hao hụt giúp giảm
              20–30% thất thoát.
            </p>

            <p className="text-justify">
              <FontAwesomeIcon icon={faCheck} className="text-success" /> Kafood
              tính tiền ăn theo ngày/khẩu phần, nghỉ–bù–hoàn, gạch nợ ngân hàng
              tự động bằng một mã cho nhiều mục (ăn, CLB, học phí), hỗ trợ trả
              một phần và tiền dư.
            </p>

            <p className="text-justify">
              <FontAwesomeIcon icon={faCheck} className="text-success" /> Báo
              cáo doanh thu–chi phí, sổ tài chính, sổ 3 bước, sổ lưu mẫu, sổ
              công khai chi chợ...
            </p>

            <p className="text-justify">
              <FontAwesomeIcon icon={faCheck} className="text-success" /> Triển
              khai cloud/self-hosted, phân quyền chi tiết, nhật ký thao tác.
            </p>

            <center className="mt-5 mb-5">
              <a href="/dang-ky-dung-thu" className="button-71">
                Đăng ký tư vấn
              </a>
            </center>
          </Col>

          <Col md={6} className="mb-3 p-3 p-md-0">
            <div className="title_home">
              <div className="text_title">
                <h2>PHẢN HỒI CỦA CÁC TRƯỜNG MẦM NON</h2>
              </div>
            </div>

            <iframe
              width="100%"
              height="300px"
              src="https://www.youtube.com/embed/4DCQxO-UfzM?si=nD0YVaUW-8FdLO7y"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerpolicy="strict-origin-when-cross-origin"
              allowfullscreen
            ></iframe>
          </Col>
        </Row>
      </div>

      <div className="container bg-light p-5 rounded-5">
        <div className="title_home">
          <div className="text_title">
            <h2>PHẢN HỒI CỦA KHÁCH HÀNG</h2>
          </div>
        </div>

        <FeedbackStrip items={dataFeedback} visible={2} speed="18s" />

        <center>
          <div className="row">
            {/* {dataFeedback.map((item, i) => {

return (

<div className="col-md-6 col-sm-4 " key={`dataFeedback${i}`}>

<div className="feedback">

<div className="title "> {item.school_name}</div>

<div className="img_">

<img src={item.src} className="rounded-circle" alt="" />

</div>

<div className="text">{item.represent}</div>

<p> {item.cmt}</p>

</div>

</div>

);

})} */}
          </div>
        </center>
      </div>

      <div className="container p-5">
        <div className="title_home">
          <div className="text_title">
            <h2>ĐỐI TÁC</h2>
          </div>

          <div className="text-center">
            Kafood luôn tận tâm đồng hành, xây dựng liên kết bền vững với Khách
            hàng và Đối tác.
          </div>

          <Row className="partner">
            <Col md={3} sm={6} xs={6} className="partner-item">
              <a
                href="https://www.vietinbank.vn/"
                target="_blank"
                title="VietinBank Cần Thơ"
              >
                <img
                  className="partner-img"
                  src="assets/images/partner/vietin-bank.png"
                  width="100%"
                  alt="Ngân hàng VietinBank Cần Thơ"
                />
              </a>
            </Col>

            <Col md={3} sm={6} xs={6} className="partner-item">
              <a
                href="https://viettel.cantho.vn/"
                target="_blank"
                title="Viettel Cần Thơ"
              >
                <img
                  className="partner-img"
                  src="assets/images/partner/viettel-can-tho.png"
                  width="100%"
                  alt="Viettel Cần Thơ"
                />
              </a>
            </Col>

            <Col md={3} sm={6} xs={6} className="partner-item">
              <a
                href="https://vbict.vn/"
                target="_blank"
                title="Bảo hiểm VietinBank Cần Thơ"
              >
                <img
                  className="partner-img"
                  src="assets/images/partner/vbi-can-tho.png"
                  width="100%"
                  alt="Bảo hiểm VietinBank Cần Thơ"
                />
              </a>
            </Col>

            <Col md={3} sm={6} xs={6} className="partner-item">
              <a href="https://hdbank.com.vn/" title="HDBank Cần Thơ">
                <img
                  className="partner-img"
                  src="assets/images/partner/hdbank.png"
                  width="100%"
                  alt="Ngân hàng HDBank Cần Thơ"
                />
              </a>
            </Col>

            <Col md={3}></Col>
          </Row>
        </div>
      </div>
    </div>
  );
}

export default HomeIndex;
